import { createRouter, createWebHashHistory } from 'vue-router'
import QintuPlatform from '../components/QintuPlatform.vue'
import Publish from '../components/publish.vue'
import ProductDetail from '../components/ProductDetail.vue'
import zixunDetail from '../components/zixunDetail.vue'
import topSearch from '../components/topSearch.vue'
import zixunlist from '../components/zixunlist.vue'
import QiList from '../components/qilist.vue'
import FindList from '../components/findlist.vue'
import SuccessPage from '../components/success.vue'
import serveList from '../components/servelist.vue'
import FaqPage from '../components/faw.vue'
import fawDetail from '../components/fawDetail.vue'
import transport from '../components/transport.vue'
import TechSpecPage from '../components/techSpec.vue'
import techSpecDetail from '../components/techSpecDetail.vue'
import FosoftechTest from '../components/loaders/FosoftechTest.vue'
import FosoftechTest2 from '../components/loaders/FosoftechTest2.vue'
import UserProfile from '../components/UserProfile.vue'
import NoticeList from '../components/NoticeList.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: QintuPlatform
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    props: true
  },
  {
      path: '/zixunDetail',
      name: 'zixunDetail',
      component: zixunDetail,
      props: true
    },
    {
      path: '/topSearch',
      name: 'topSearch',
      component: topSearch,
      props: true
    },
    {
      path: '/zixunlist',
      name: 'zixunlist',
      component: zixunlist,
      props: true
    },
      {
        path: '/qilist',
        name: 'qilist',
        component: QiList,
        props: true
      },
      {
        path: '/findlist',
        name: 'findlist',
        component: FindList,
        props: true
      },
      {
        path: '/serveList',
        name: 'serveList',
        component: serveList,
        props: true
      },
      {
        path: '/faw',
        name: 'FaqPage',
        component: FaqPage,
        props: true
      },
      {
        path: '/fawDetail',
        name: 'fawDetail',
        component: fawDetail
      },
     
      {
        path: '/transport',
        name: 'transport',
        component: transport,
        props: true
      },
      {
        path: '/techSpec',
        name: 'TechSpecPage',
        component: TechSpecPage,
        props: true
      },
      {
        path: '/techSpecDetail',
        name: 'techSpecDetail',
        component: techSpecDetail
      }
      ,
        {
          path: '/publish',
          name: 'publish',
          component: Publish,
          props: route => ({ ...route.query })
        }
      ,
      {
        path: '/success',
        name: 'success',
        component: SuccessPage,
        props: true
      },
      {
        path: '/fosoftech-test',
        name: 'FosoftechTest',
        component: FosoftechTest
      },
      {
        path: '/fosoftech-test2',
        name: 'FosoftechTest2',
        component: FosoftechTest2
      },
      {
        path: '/user-profile',
        name: 'UserProfile',
        component: UserProfile
      },
      {
        path: '/notice-list',
        name: 'NoticeList',
        component: NoticeList
      }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则返回保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则始终滚动到页面顶部
      return { top: 0, left: 0 }
    }
  }
})

// 添加全局导航守卫，检查登录状态
router.beforeEach((to, from, next) => {
  // 显示加载页面（如果不是首次加载）
  if (from.name !== null && window.showAppLoading) {
    window.showAppLoading()
  }
  
  // 需要登录才能访问的页面
  const requiresAuth = ['findlist', 'qilist', 'ProductDetail', 'success', 'UserProfile', 'NoticeList']
  
  // 检查是否需要登录且用户未登录
  if (requiresAuth.includes(to.name) && localStorage.getItem('isLoggedIn') !== 'true') {
    // 保存用户尝试访问的路径
    localStorage.setItem('redirectPath', to.fullPath)
    
    // 阻止跳转
    next(false)
    
    // 显示登录弹窗（通过window对象调用topHeader组件的方法）
    if (window.showLoginDialog) {
      window.showLoginDialog()
    } else {
      // 如果window对象上还没有showLoginDialog方法，延迟执行
      setTimeout(() => {
        if (window.showLoginDialog) {
          window.showLoginDialog()
        }
      }, 100)
    }
    
    // 如果显示了登录弹窗，隐藏加载页面
    if (window.hideAppLoading) {
      setTimeout(() => {
        if (window.hideAppLoading) {
          window.hideAppLoading()
        }
      }, 300)
    }
  } else {
    // 允许正常跳转
    next()
  }
})

// 路由跳转完成后隐藏加载页面
router.afterEach(() => {
  if (window.hideAppLoading) {
    window.hideAppLoading()
  }
})


export default router
